import React, { useEffect, useMemo, useState } from 'react';

export const SearchableSelect = ({
  value = '',
  options = [],
  onChange,
  placeholder = 'Escribe para buscar…',
  allowFreeText = false,
  disabled = false,
  style = {},
  dropdownStyle = {},
  isDarkMode = false,
  maxResults = 20,
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  const selected = useMemo(
    () => options.find((option) => String(option.value) === String(value)) || null,
    [options, value]
  );

  useEffect(() => {
    if (!open) {
      setQuery(allowFreeText ? String(value || '') : String(selected?.label || ''));
    }
  }, [value, selected, allowFreeText, open]);

  const filtered = useMemo(() => {
    const q = String(query || '').trim().toLowerCase();
    const limit = Math.max(1, Number(maxResults) || 20);
    const list = (options || []).filter((option) => option.value !== '' && option.value != null);
    if (!q) return list.slice(0, limit);
    return list
      .filter((option) => {
        const label = String(option.label || '').toLowerCase();
        const val = String(option.value || '').toLowerCase();
        const name = String(option.name || '').toLowerCase();
        const extra = String(option.sku || option.code || '').toLowerCase();
        return label.includes(q) || val.includes(q) || name.includes(q) || extra.includes(q);
      })
      .slice(0, limit);
  }, [options, query, maxResults]);

  const panelBg = isDarkMode ? '#18181b' : '#fff';
  const border = isDarkMode ? '#3f3f46' : '#d1d5db';
  const text = isDarkMode ? '#e4e4e7' : '#111827';
  const muted = isDarkMode ? '#a1a1aa' : '#6b7280';

  const displayValue = open
    ? query
    : allowFreeText
      ? String(value || '')
      : String(selected?.label || '');

  return (
    <div style={{ position: 'relative' }}>
      <input
        style={style}
        value={displayValue}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete="off"
        onFocus={() => {
          if (disabled) return;
          setQuery(allowFreeText ? String(value || '') : String(selected?.label || ''));
          setOpen(true);
        }}
        onBlur={() => {
          setTimeout(() => setOpen(false), 140);
        }}
        onChange={(event) => {
          const next = event.target.value;
          setQuery(next);
          setOpen(true);
          if (allowFreeText) onChange?.(next, null);
        }}
      />
      {open && !disabled ? (
        <div
          style={{
            position: 'absolute',
            top: '36px',
            left: 0,
            right: 0,
            maxHeight: 180,
            overflowY: 'auto',
            background: panelBg,
            border: `1px solid ${border}`,
            borderRadius: 8,
            zIndex: 20,
            ...dropdownStyle,
          }}
        >
          {filtered.length === 0 ? (
            <div style={{ padding: '8px 10px', fontSize: 12, color: muted }}>
              {allowFreeText && String(query || '').trim()
                ? `Se creará con: “${String(query).trim()}”`
                : 'Sin coincidencias'}
            </div>
          ) : (
            filtered.map((option) => (
              <button
                key={String(option.value)}
                type="button"
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => {
                  onChange?.(option.value, option);
                  setQuery(option.label || option.value);
                  setOpen(false);
                }}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px 10px',
                  border: 'none',
                  background: 'transparent',
                  color: text,
                  cursor: 'pointer',
                  fontSize: 13,
                }}
              >
                {option.label}
              </button>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SearchableSelect;
